import classNames from 'classnames';
import SVGIcon from '../../atoms/icons';
import TextArea from '../../atoms/text-area';
import Text from '../../atoms/text';
import SectionHeader from './section-header';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MonitoringForm } from './containers';

export interface GeneralProblemForm {
	isProblem: boolean;
	description: string;
}

interface GeneralProblemProps {
	data: GeneralProblemForm;
	setData: React.Dispatch<React.SetStateAction<GeneralProblemForm>>;
	monitorings: MonitoringForm[];
	aoAlterarDescricao: (descricao: string) => void;
}

const GeneralProblem = ({
	data,
	setData,
	monitorings,
	aoAlterarDescricao,
}: GeneralProblemProps) => {
	const { t } = useTranslation();

	const problemLabel: Record<number, string> = {
		0: t('misc.none'),
		1: t('monitor.yard_problem'),
	};

	const toggleGeneralProblem = () => {
		setData((prev) => ({
			...prev,
			isProblem: !prev.isProblem,
		}));
	};

	const handleDescricao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const descricao = e.target.value;
		setData((prev) => ({
			...prev,
			description: descricao,
		}));
		aoAlterarDescricao(descricao);
	};

	return (
		<div className="grid gap-3 border border-primary rounded-lg w-full">
			<SectionHeader title={t('monitor.report_general_problem')} />
			<div className="grid gap-6 p-3">
				<div className="flex flex-col gap-1 items-center">
					<div
						className={classNames(
							'size-36 rounded-md flex items-center justify-center cursor-pointer select-none',
							{
								'bg-gray': !data.isProblem,
								'bg-red': data.isProblem,
								'pointer-events-none': monitorings.length == 0,
							}
						)}
						onClick={toggleGeneralProblem}
					>
						<SVGIcon
							className="h-24 w-auto"
							icon="Socket"
							fill={!data.isProblem ? '#bfbfbf' : '#e53935'}
						/>
					</div>
					<Text
						className={classNames({
							'text-gray-label': !data.isProblem,
							'text-red font-semibold': data.isProblem,
						})}
					>
						{problemLabel[Number(data.isProblem)]}
					</Text>
				</div>
				<TextArea
					className="w-full"
					rows={4}
					placeholder={t('misc.description')}
					value={data.description}
					onChange={handleDescricao}
				/>
			</div>
		</div>
	);
};

export default GeneralProblem;
